import { multiFactorAuthTranslations } from 'translations';

export const isMfaAccountSettingsVisible = access => access.canViewMFA() && access.canManageMFASettings();

export const tilesConfig = [
    {
        id: 'mfa-account-settings',
        title: multiFactorAuthTranslations.ng_multiFactorAuthentication_title,
        description: multiFactorAuthTranslations.ng_multiFactorAuthentication_menuDescription,
        path: '/mfa-account-settings',
        visible: access => isMfaAccountSettingsVisible(access)
    }
];
